import { StateObject } from "@/dtos/State.dto";
import Billing from "@/services/billing/billing";
import {
  CLEAR_BILLING_ISLOADING,
  CREATE_SETUP_CHECKOUT,
  GET_INVOICES,
  GET_PAYMENT_METHODS,
  GET_USAGE_HISTORY,
  GET_USAGE_STATS,
} from "@/store/action-types";
import {
  CLEAR_PERSISTENT_BANNER,
  SET_INVOICES,
  SET_PAYMENT_METHODS,
  SET_PERSISTENT_BANNER,
  SET_USAGE_HISTORY,
  SET_USAGE_STATS,
} from "@/store/mutation-types";
import { AxiosResponse } from "axios";
import { Module } from "vuex";

const billing: Module<any, {}> = {
  state: {
    usageStats: {
      data: null,
      isLoading: false,
    },
    usageHistory: {
      data: null,
      isLoading: false,
    },
    invoices: {
      data: null,
      isLoading: false,
    },
    paymentMethods: {
      data: null,
      isLoading: false,
    },
    persistentBanner: null as {
      type: "warning" | "error" | "info";
      message: string;
      dismissible: boolean;
    } | null,
  },
  getters: {
    usageStats: (state: { usageStats: any }) => state.usageStats,
    usageHistory: (state: { usageHistory: any }) => state.usageHistory,
    invoices: (state: { invoices: any }) => state.invoices,
    paymentMethods: (state: { paymentMethods: any }) => state.paymentMethods,
    persistentBanner: (state: { persistentBanner: any }) => state.persistentBanner,
  },
  mutations: {
    [SET_USAGE_STATS]: (
      state: { usageStats: StateObject },
      payload: { data: null; isLoading: any }
    ) => {
      if (payload.data != null) state.usageStats.data = payload.data;
      state.usageStats.isLoading = payload.isLoading;
    },
    [SET_USAGE_HISTORY]: (
      state: { usageHistory: StateObject },
      payload: { data: null; isLoading: any }
    ) => {
      if (payload.data != null) state.usageHistory.data = payload.data;
      state.usageHistory.isLoading = payload.isLoading;
    },
    [SET_INVOICES]: (state: { invoices: StateObject }, payload: { data: null; isLoading: any }) => {
      if (payload.data != null) state.invoices.data = payload.data;
      state.invoices.isLoading = payload.isLoading;
    },
    [SET_PAYMENT_METHODS]: (
      state: { paymentMethods: StateObject },
      payload: { data: null; isLoading: any }
    ) => {
      if (payload.data != null) state.paymentMethods.data = payload.data;
      state.paymentMethods.isLoading = payload.isLoading;
    },
    [SET_PERSISTENT_BANNER]: (
      state: { persistentBanner: any },
      payload: { type: "warning" | "error" | "info"; message: string; dismissible: boolean }
    ) => {
      state.persistentBanner = payload;
    },
    [CLEAR_PERSISTENT_BANNER]: (state: { persistentBanner: any }) => {
      state.persistentBanner = null;
    },
  },
  actions: {
    [GET_USAGE_STATS]: async ({ commit }: any, payload: any) => {
      commit(SET_USAGE_STATS, { data: null, isLoading: true });
      try {
        const result: AxiosResponse = await Billing.getUsageStats(payload);
        if (result?.data?.status) {
          commit(SET_USAGE_STATS, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_USAGE_STATS, { data: null, isLoading: false });
        return null;
      } catch (error) {
        commit(SET_USAGE_STATS, { data: null, isLoading: false });
        return null;
      }
    },
    [GET_USAGE_HISTORY]: async ({ commit }: any, payload: any) => {
      commit(SET_USAGE_HISTORY, { data: null, isLoading: true });
      try {
        const result: AxiosResponse = await Billing.getUsageHistory(payload);
        if (result?.data?.status) {
          commit(SET_USAGE_HISTORY, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_USAGE_HISTORY, { data: null, isLoading: false });
        return null;
      } catch (error) {
        commit(SET_USAGE_HISTORY, { data: null, isLoading: false });
        return null;
      }
    },
    [GET_INVOICES]: async ({ commit }: any) => {
      commit(SET_INVOICES, { data: null, isLoading: true });
      try {
        const result: AxiosResponse = await Billing.getInvoices();
        if (result?.data?.status) {
          commit(SET_INVOICES, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_INVOICES, { data: null, isLoading: false });
        return null;
      } catch (error) {
        commit(SET_INVOICES, { data: null, isLoading: false });
        return null;
      }
    },
    [GET_PAYMENT_METHODS]: async ({ commit }: any) => {
      commit(SET_PAYMENT_METHODS, { data: null, isLoading: true });
      try {
        const result: AxiosResponse = await Billing.getPaymentMethods();
        if (result?.data?.status) {
          commit(SET_PAYMENT_METHODS, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_PAYMENT_METHODS, { data: null, isLoading: false });
        return null;
      } catch (error) {
        commit(SET_PAYMENT_METHODS, { data: null, isLoading: false });
        return null;
      }
    },
    [CLEAR_BILLING_ISLOADING]: ({ commit }) => {
      commit(SET_USAGE_STATS, { isLoading: false });
      commit(SET_USAGE_HISTORY, { isLoading: false });
      commit(SET_INVOICES, { isLoading: false });
      commit(SET_PAYMENT_METHODS, { isLoading: false });
    },
    [CREATE_SETUP_CHECKOUT]: async (_: any, payload?: { returnPath?: string }) => {
      try {
        const result: AxiosResponse = await Billing.createSetupCheckout(payload?.returnPath);
        if (result?.data?.status) {
          return result.data.data;
        }
        return null;
      } catch (error) {
        return null;
      }
    },
  },
};

export default billing;
